export const parseMarkupToModel = (markup) => ({
    ...markup,
});

export const parseMarkupToObject = (data) => ({
    ...data,
});
